export const FormCopyStep = {
  /** Step 1: copy form row created */
  FormCreated: 0,
  /** Step 2: virtual fields copied */
  VirtualFields: 1,
  /** Step 3: questionnaires copied */
  Questionnaires: 2,
  /** Step 4: field mapping copied */
  FieldMapping: 3,
  /** Step 5: confirmation */
  DataConfirmed: 4,
  /** Step 6: workflows copied */
  Workflows: 5,
  /** Step 7: matters copied */
  Matters: 6,
} as const;

export const FormCopyStatus = {
  InProgress: 1,
  Completed: 2,
} as const;
